import { defineMessages } from 'react-intl';

/**
 * Accessibility strings for the examples column (iframe titles).
 * Use with {@link useIntl} `formatMessage` in the examples section and variant hook.
 */
export const examplesSectionMessages: {
	incidentsVideoIframeTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	workforceOptimizationVideoIframeTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	incidentsVideoIframeTitle: {
		id: '@atlassian/edition-benefits-modal.examples-section.incidents-video.iframe-title',
		defaultMessage: 'YouTube video player',
		description: 'Accessible title for the incidents Slack integration YouTube embed iframe',
	},
	workforceOptimizationVideoIframeTitle: {
		id: '@atlassian/edition-benefits-modal.examples-section.iframe-title.workforce-optimization',
		defaultMessage: 'Workforce Optimization video',
		description: 'Accessible iframe title for the WFO Premium upsell video pane',
	},
});
